import PropTypes from 'prop-types';
import luchitoIntro from 'assets/images/digital-loan/luchito-intro.png';
import { ReactComponent as CheckIcon } from 'assets/icons/digital-loan-check.svg';
import Button from 'components/UI/Button';
import { ROUTE_PATH } from 'routes';

const IntroScreen = ({ literals, onContinue }) => (
  <div className='full-screen-container digital-loan-intro'>
    <div className='screen-content'>
      <div className='digital-loan-intro__hero-wrap'>
        <img
          className='digital-loan-intro__hero'
          src={luchitoIntro}
          alt={literals.heroAlt}
        />
      </div>
      <h1 className='digital-loan-intro__title'>{literals.title}</h1>
      <p className='digital-loan-intro__subtitle'>{literals.subtitle}</p>
      <p className='digital-loan-intro__requirements-title font-bold'>
        {literals.requirementsTitle}
      </p>
      <ul className='digital-loan-intro__requirements'>
        {literals.requirements.map((item) => (
          <li key={item} className='digital-loan-intro__requirement-item'>
            <CheckIcon className='digital-loan-intro__check' aria-hidden='true' />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
    <div className='screen-actions digital-loan-intro__actions'>
      <Button text={literals.apply} onClick={onContinue} />
      <Button
        className='digital-loan-intro__later'
        text={literals.later}
        type='secondary'
        to={ROUTE_PATH.HOME}
      />
    </div>
  </div>
);

IntroScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default IntroScreen;
